module.exports = __webpack_public_path__ + "static/media/img_top_gift@2x.21d76aef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/PC/@2x/img_top_gift@2x.png
// module id = 784
// module chunks = 0